export const API = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "texoma_admin_token";
export const ROLE_KEY = "texoma_admin_role";
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` });
export const fmtDate = (iso) =>
  iso ? new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
